export const OrgLeftSidebarTestIds = {
  sidebarHeaderIcon: 'sidebar_header_icon',
  adminsidebarHeaderIcon: 'adminsidebar_header_icon',
  listContainer: 'list_container',
  sidebarFooter: 'sidebar_footer',
  buttonToggleSideNav: 'button_toggleSideNav',
  dropdownDomainPrefix: 'dropdown_domain_',
  listGeneralUsers: 'list_general_users',
  listItemReportsPrefix: 'list_item_reports',
  listItemHealthcarePrefix: 'list_item_healthcare',
  listItemServerconfigPrefix: 'list_item_serverconfig',
  buttonLogout: 'button_logout'
} as const;
